import React, { useState, useEffect, useRef, useMemo } from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Button, IconButton, Pagination } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { timeAgo, formatDate, formatTimeUTCandIST, } from '../../utils/dateTime';

import UserTableSkeleton from '../user-management/UserTableSkeleton';
import Tooltip from '@mui/material/Tooltip';
import UserProfileMainPage from '../user-profile-main/UserProfileMainPage';
import { setSearchTermAction } from '../../containers/app-container/reducer/filterSlice';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { initColumns, toggleColumn } from '../../containers/app-container/reducer/visibleColumnsSlice';
import { fetchDeletedAccountList } from '../../api/deletedAccount';
import { downloadCsv } from '../../utils/fileUtils';
import { ExportIcon } from '../../icons';
import { useNotification } from '../../hooks/useNotification';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 600,
    width: '95%',
    margin: '0 auto',
    bgcolor: 'background.paper',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh', // Adjust the height for scrolling
    overflow: 'auto', // Make content scrollable
};
const styleUser = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1080,
    width: '95%',
    margin: '0 auto',
    bgcolor: 'background.paper',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
    maxHeight: '80vh', // Adjust the height for scrolling
    overflow: 'auto', // Make content scrollable
};
export const style2 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1300,
    width: '95%',
    margin: '0 auto',
    bgcolor: 'background.paper',
    borderRadius: '20px',
    boxShadow: 24,
    p: '0 30px 30px 30px',
    maxHeight: '80vh', // Adjust the height for scrolling
    overflow: 'auto', // Make content scrollable
};

const visibleColumnKey = ['email', 'age', 'gender', 'location', 'userName', 'subscription', 'registrationDate','deletionDate', 'profileCompletion', 'step', 'session', 'verification', 'accountStatus', 'action', 'firstName']
const DeletedAccountList = () => {
    const searchTermFromStore = useSelector((state) => state.filter.searchTerm);
    const dispatch = useDispatch()
    const { showSuccessNotification, showErrorNotification } = useNotification();
    const debounceTimeoutRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState(null);
    const [open, setOpen] = useState(false);
    const [openSuspend, setOpenSuspend] = useState(false);
    const [openProfile, setOpenProfile] = useState(false);
    const [userData, setUserData] = useState([]);
    const visibleColumns = useSelector(state => state.visibleColumns.pages.deleted_account || {});
    const fullFilter = useSelector((state) => state.filter);
    const [currentPage, setCurrentPage] = useState(1);
    const filterWithoutUTM = useMemo(() => {
        const { utm_options, ...rest } = fullFilter;
        setCurrentPage(1)  //reset to pg 1 when filter change
        return rest;
    }, [JSON.stringify(fullFilter)]);


    const { filter } = useSelector((state) => state);
    const [selectedUser, setSelectedUser] = useState(false);
    const [pageLimit, setPageLimit] = useState(25);
    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(false);
    const [exporting, setExporting] = useState(false);

    const tableContainerRef = useRef(null);
    const scrollThumbRef = useRef(null);
    const [scrollState, setScrollState] = useState({
        scrollLeft: 0,
        scrollWidth: 0,
        clientWidth: 0,
    });


    const thumbWidth = useMemo(() => {
        if (scrollState.scrollWidth > 0 && scrollState.clientWidth > 0) {
            const ratio = scrollState.clientWidth / scrollState.scrollWidth;
            return Math.max(ratio * scrollState.clientWidth, 50);
        }
        return 100;
    }, [scrollState]);

    // Scroll thumb position
    const thumbPosition = useMemo(() => {
        if (scrollState.scrollWidth > 0 && scrollState.clientWidth > 0) {
            const ratio = scrollState.scrollLeft / (scrollState.scrollWidth - scrollState.clientWidth);
            return ratio * (scrollState.clientWidth - thumbWidth);
        }
        return 0;
    }, [scrollState, thumbWidth]);

    const updateScrollState = () => {
        if (tableContainerRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = tableContainerRef.current;
            setScrollState({
                scrollLeft,
                scrollWidth,
                clientWidth,
            });
        }
    };

    const handleTableScroll = () => {
        updateScrollState();
    };

    const handleStickyScroll = (e) => {
        if (!tableContainerRef.current) return;

        const track = e.currentTarget;
        const trackRect = track.getBoundingClientRect();
        const clickX = e.clientX - trackRect.left;
        const thumbCenter = thumbWidth / 2;

        const newScrollLeft = (clickX - thumbCenter) / (trackRect.width - thumbWidth) *
            (scrollState.scrollWidth - scrollState.clientWidth);

        tableContainerRef.current.scrollLeft = newScrollLeft;
    };

    const handleThumbDrag = (e) => {
        e.preventDefault();
        const startX = e.clientX;
        const startScrollLeft = scrollState.scrollLeft;

        const handleMouseMove = (moveEvent) => {
            const deltaX = moveEvent.clientX - startX;
            const trackWidth = scrollState.clientWidth - thumbWidth;
            const scrollableWidth = scrollState.scrollWidth - scrollState.clientWidth;

            if (trackWidth > 0) {
                const newScrollLeft = startScrollLeft + (deltaX / trackWidth) * scrollableWidth;
                if (tableContainerRef.current) {
                    tableContainerRef.current.scrollLeft = Math.max(0, Math.min(newScrollLeft, scrollableWidth));
                }
            }
        };

        const handleMouseUp = () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    useEffect(() => {
        updateScrollState();
        window.addEventListener('resize', updateScrollState);

        return () => {
            window.removeEventListener('resize', updateScrollState);
        };
    }, [userData, visibleColumns]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const data = await fetchDeletedAccountList({
                filter: { ...filter, requestType: "deleted_accounts" },
                setUserData,
                page: currentPage,
                limit: pageLimit,
                skip: 0,
                isBot: false,
                searchTerm: filterWithoutUTM?.searchTerm
            });
            setTotalUsers(data.totalUsersCount);
            setTotalPages(data.totalPages);
        } catch (err) {
            console.error('Error while loading user data', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [JSON.stringify(filterWithoutUTM), currentPage]);
    const handleOpen = (user) => {
        setSelectedUser(user);
        setOpen(true);
    };

    const handleOpenProfile = (user) => {
        setSelectedUser(user);
        setOpenProfile(true);
    };

    const handleCloseProfile = () => setOpenProfile(false);
    const handleColumnToggle = (key) => {
        dispatch(
            toggleColumn({
                pageKey: "deleted_account",
                column: key
            }));
    };

    const filteredData = userData

    const handlePageChange = (event, page) => {
        setCurrentPage(page);
    };

    const columnHeaders = [
        { key: 'email', label: 'Email' },
        { key: 'age', label: 'Age' },
        { key: 'gender', label: 'Gender' },
        { key: 'location', label: 'Location' },
        { key: 'userName', label: 'Username' },
        { key: 'firstName', label: 'First Name' },
        { key: 'subscription', label: 'Subscription Status' },
        { key: 'registrationDate', label: 'Registration Date' },
        { key: 'deletionDate', label: 'Deleted On' },
        { key: 'profileCompletion', label: 'Profile Completion' },
        { key: 'step', label: 'Step' },
        { key: 'verification', label: 'Verification' },
        { key: 'accountStatus', label: 'Account Status' },
        { key: 'action', label: 'Action' },
    ];

    useEffect(() => {
        dispatch(
            initColumns({
                pageKey: "deleted_account",
                columns: visibleColumnKey
            })
        );
    }, []);

    useEffect(() => {
        if (searchTerm === undefined || searchTerm === null) return

        clearTimeout(debounceTimeoutRef.current);

        debounceTimeoutRef.current = setTimeout(() => {
            dispatch(setSearchTermAction({ searchTerm }))
        }, 300);

        return () => {
            clearTimeout(debounceTimeoutRef.current);
        };
    }, [searchTerm]);

    useEffect(() => {
        if (searchTermFromStore == null && searchTerm) setSearchTerm(null);
    }, [searchTermFromStore])

    // CSV export — columns mirror the table (and respect the visible-columns
    // selection), minus the non-data Action column.
    const exportHeaders = [
        { key: 'email', label: 'Email' },
        { key: 'age', label: 'Age' },
        { key: 'gender', label: 'Gender' },
        { key: 'location', label: 'Location' },
        { key: 'userName', label: 'Username' },
        { key: 'firstName', label: 'First Name' },
        { key: 'subscription', label: 'Subscription Status' },
        { key: 'registrationDate', label: 'Registration Date' },
        { key: 'deletionDate', label: 'Deleted On' },
        { key: 'profileCompletion', label: 'Profile Completion' },
        { key: 'step', label: 'Step' },
        { key: 'verification', label: 'Verification' },
        { key: 'accountStatus', label: 'Account Status' },
    ];

    // CSV twin of the Account Status cell — kept in step with it (and with the Sign Ups
    // list's own Deleted label) rather than reporting the frozen pre-deletion flags.
    const getAccountStatusLabel = () => 'Deleted';

    // Canonical onboarding step ("<number> · <name>") — the furthest step the user
    // reached / dropped at, using the SAME taxonomy as the Onboarding Drop-off funnel and
    // the User Management list. Server (getDeletedAccounts) derives ghostStep/ghostStepLabel
    // from the delete-log via helpers/ghostFunnel.js. Falls back to the raw step number if
    // a stale backend hasn't shipped the canonical fields yet.
    const formatGhostStep = (user) => {
        if (user?.ghostStep) {
            return user?.ghostStepLabel ? `${user.ghostStep} · ${user.ghostStepLabel}` : `${user.ghostStep}`;
        }
        // Stale-backend fallback only. Prefer stepName — the screen the member last saved.
        // Since the 2026-08-25 reorder the raw `step` is the highest MARKER ever sent, not a
        // position in the flow (it reads 17 for everyone past the Work Field screen), so it is
        // the weaker of the two and must not be preferred over a name.
        return user?.stepName || (user?.step ?? '');
    };

    const mapUserToCsvRow = (user) => ({
        email: user?.email ?? '',
        age: user?.age ?? '',
        gender: user?.gender ?? '',
        location: [user?.city, user?.state, user?.country].filter(Boolean).join(', '),
        userName: user?.userName ?? '',
        firstName: user?.firstName ?? '',
        subscription: user?.isSubscribed ? 'Paid' : 'Free',
        registrationDate: user?.accountSince ? `${formatDate(user.accountSince)} ${formatTimeUTCandIST(user.accountSince)}` : '-',
        deletionDate: user?.createdAt ? `${formatDate(user.createdAt)} ${formatTimeUTCandIST(user.createdAt)}` : '',
        profileCompletion: user?.profileCompletion ?? '',
        step: formatGhostStep(user),
        verification: user?.isProfileVerified ? 'Verified' : 'Pending',
        accountStatus: getAccountStatusLabel(user),
    });

    const handleExport = async () => {
        const headers = exportHeaders.filter((header) => visibleColumns[header.key]);
        if (!headers.length) {
            showErrorNotification('Select at least one column to export');
            return;
        }
        try {
            setExporting(true);
            // Fetch the entire filtered set (not just the current page). A no-op
            // setUserData keeps the paginated table untouched; rows come from the
            // returned payload.
            const exportLimit = totalUsers && totalUsers > 0 ? totalUsers : 100000;
            const response = await fetchDeletedAccountList({
                filter: { ...filter, requestType: 'deleted_accounts' },
                setUserData: () => { },
                page: 1,
                limit: exportLimit,
                skip: 0,
                isBot: false,
                searchTerm: filterWithoutUTM?.searchTerm,
            });
            const rows = (response?.users || []).map(mapUserToCsvRow);
            downloadCsv({ fileName: 'deleted-accounts.csv', headers, rows });
            showSuccessNotification(`Exported ${rows.length} account${rows.length === 1 ? '' : 's'}`);
        } catch (err) {
            console.error('Error while exporting deleted accounts', err);
            showErrorNotification(err?.response?.data?.message || err?.message || 'Failed to export deleted accounts');
        } finally {
            setExporting(false);
        }
    };



    return (
        <>
            <div className="mb-16 d-flex justify-content-between align-items-center">
                <h6 className="text-lg mb-0">User List</h6>
                <div className="d-flex align-items-center gap-2">
                    <form className="navbar-search">
                        <input
                            type="text"
                            name="search"
                            placeholder="Search"
                            value={searchTerm || ''}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <span className="icon">
                            <iconify-icon icon="ion:search-outline"></iconify-icon>
                        </span>
                    </form>
                    <Tooltip title={exporting ? 'Exporting…' : 'Export all'} arrow placement="top">
                        <button
                            className="badge text-sm fw-medium border bg-transparent px-10 py-10 radius-6 text-secondary-light"
                            type="button"
                            onClick={handleExport}
                            disabled={exporting || loading}
                        >
                            <ExportIcon />
                        </button>
                    </Tooltip>
                    <div className="dropdown">
                        <Tooltip title="Manage Columns" arrow placement="top">
                            <button
                                className="badge text-sm fw-medium border bg-transparent px-10 py-10 radius-6 text-secondary-light"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <ViewColumnOutlinedIcon />
                            </button>
                        </Tooltip>
                        <ul className="dropdown-menu manage-list">
                            {columnHeaders.map((column) => (
                                <li
                                    key={column.key}
                                    className="dropdown-item d-flex align-items-center gap-2"
                                >
                                    <input
                                        className="form-check-input"
                                        style={{ width: '18px', height: '18px' }}
                                        type="checkbox"
                                        checked={visibleColumns[column.key]}
                                        onChange={() => handleColumnToggle(column.key)}
                                    />
                                    {column.label}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="table-scroll-container">
                <div  
                    ref={tableContainerRef}
                    className="custom-horizontal-scroll scroll-sm tablebtmdropnewclass"
                    onScroll={handleTableScroll}
                    style={{ 
    maxHeight: 'calc(100vh - 250px)', // Adjust this value as needed
    overflow: 'auto',
    position: 'relative'
  }}
                >
                    <table className="table bordered-table sm-table mb-0" style={{ position: 'relative' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                            <tr style={{ background: '#f4f4f4', textAlign: 'left' }}>
                                <th>#</th>
                                {visibleColumns.name && <th>Name</th>}
                                {visibleColumns.email && <th className="text-center">Email</th>}
                                {visibleColumns.age && <th className="text-center">Age</th>}
                                {visibleColumns.gender && <th className="text-center">Gender</th>}
                                {visibleColumns.location && (
                                    <th className="text-center">Location</th>
                                )}
                                {visibleColumns.userName && (
                                    <th className="text-center">Username</th>
                                )}
                                {visibleColumns.firstName && (
                                    <th className="text-center">First Name</th>
                                )}
                                {visibleColumns.subscription && (
                                    <th className="text-center">Subscription Status</th>
                                )}
                                {visibleColumns.registrationDate && (
                                    <th className="text-center">Registration Date</th>
                                )}
                                 {visibleColumns.deletionDate && (
                                    <th className="text-center">Deleted On</th>
                                )}
                                {visibleColumns.profileCompletion && (
                                    <th className="text-center">Profile Completion</th>
                                )}
                                {visibleColumns.step && (
                                    <th className="text-center">Step</th>
                                )}
                                {visibleColumns.verification && (
                                    <th className="text-center">Verification</th>
                                )}
                                {visibleColumns.accountStatus && (
                                    <th className="text-center">Account Status</th>
                                )}
                                {visibleColumns.lastLogin && (
                                    <th className="text-center">Last Login</th>
                                )}
                                {visibleColumns.action && <th className="text-center">Action</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <UserTableSkeleton
                                    rows={10}
                                    columns={Object.keys(visibleColumns).filter((key) => visibleColumns[key]).length + 1}
                                />
                            ) : filteredData.length > 0 ? (
                                filteredData.map((user, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                        {/* <td>{index + 1}</td> */}
                                        {visibleColumns.name && (
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={user.image}
                                                        alt=""
                                                        className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12 overflow-hidden"
                                                    />
                                                    <div className="flex-grow-1">
                                                        <h6 className="text-md mb-0 fw-medium">
                                                            {user.name}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </td>
                                        )}
                                        {visibleColumns.email && (
                                            <td className="text-center">{user.email}</td>
                                        )}
                                        {visibleColumns.age && (
                                            <td className="text-center">{user.age}</td>
                                        )}
                                        {visibleColumns.gender && (
                                            <td className="text-center">{user.gender}</td>
                                        )}
                                        {visibleColumns.location && (
                                            <td className="text-center">
                                                {[user.city, user.state, user.country].filter(Boolean).join(", ")}
                                            </td>
                                        )}
                                        {visibleColumns.userName && (
                                            <td className="text-center">{user?.userName}</td>
                                        )}
                                        {visibleColumns.firstName && (
                                            <td className="text-center">{user?.firstName}</td>
                                        )}
                                        {visibleColumns.subscription && (
                                            <td className="text-center">
                                                 <div className="freesub">{user?.isSubscribed ? "Paid" : "Free"}</div>
                                            </td>
                                        )}
                                        {visibleColumns.registrationDate && (
                                            <td className="text-center">
                                                {user.accountSince ? `${formatDate(user.accountSince)} ${formatTimeUTCandIST(user.accountSince)}` : "-"}
                                            </td>
                                        )}
                                        {visibleColumns.deletionDate && (
                                            <td className="text-center">
                                                {formatDate(user?.createdAt)} {formatTimeUTCandIST(user?.createdAt)}
                                            </td>
                                        )}
                                        {visibleColumns.profileCompletion && (
                                            <td className="text-center">
                                                {user.profileCompletion}
                                            </td>
                                        )}
                                        {visibleColumns.step && (
                                            <td className="text-center">
                                                {formatGhostStep(user)}
                                            </td>
                                        )}
                                        {visibleColumns.verification && (
                                            <td className="text-center">
                                                <div className="d-flex align-items-center justify-content-center gap-10 verification">
                                                    {user.isProfileVerified && (
                                                        <img
                                                            src="/assets/images/admin-panel/verified.svg"
                                                            className="img-fluid"
                                                            alt="verification"
                                                        />
                                                    )}
                                                    {user.isProfileVerified ? 'Verified' : 'Pending'}
                                                </div>
                                            </td>
                                        )}
                                        {/* Account Status */}
                                        {visibleColumns.accountStatus && (
                                            // Every row here IS a deleted account, so the status is `Deleted` —
                                            // same label and chip the attribution Sign Ups list gives these people
                                            // (UserList's getUserStatus). It used to read the frozen suspend /
                                            // isInvisible / active flags off the dump and report "Active" for
                                            // someone who no longer exists; those flags describe the state they
                                            // left in, not an account status. "Deleted On" carries the when.
                                            <td className="accountStatus text-center text-white bg-neutral-600">
                                                Deleted
                                            </td>
                                        )}
                                        {visibleColumns.lastLogin && (
                                            <td className="text-center">
                                                <div className="d-flex align-items-center gap-10 lastLogin justify-content-end">
                                                    {user.lastActive ? timeAgo(user.lastActive) : '-'}
                                                </div>
                                            </td>
                                        )}
 
                                        {visibleColumns.action && (
                                            <>
                                                <td>
                                                    <FormControl fullWidth>
                                                        <Select
                                                            value=""
                                                            displayEmpty
                                                            renderValue={() => 'Action'}
                                                            IconComponent={KeyboardArrowDownIcon}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        boxShadow: 'rgba(46, 45, 116, 0.05) 0px 13px 30px 10px',
                                                                        borderRadius: '16px',
                                                                        mt: 1,
                                                                        border: '1px solid #ccc',
                                                                        p: 0
                                                                    }
                                                                },
                                                                MenuListProps: {
                                                                    sx: {
                                                                        backgroundColor: '#fff',
                                                                        padding: '10px 0'
                                                                    }
                                                                }
                                                            }}
                                                            // className='toggle-icon'
                                                            sx={{
                                                                border: '1px solid #487FFF',
                                                                bgcolor: '#487FFF',
                                                                color: '#fff',
                                                                fontFamily: 'indivisible',
                                                                fontWeight: '500',
                                                                fontSize: '14px',
                                                                borderRadius: '6px',
                                                                height: '35px',
                                                                width: '100px',
                                                                cursor: 'pointer',

                                                                '& .MuiSelect-select': {
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    cursor: 'pointer',
                                                                    textAlign: 'left',
                                                                    paddingLeft: '12px'
                                                                },
                                                                ' & .MuiMenuItem-root': {
                                                                    backgroundColor: 'none !important'
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    fill: '#fff'
                                                                },

                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    border: 'none'
                                                                },

                                                                '&.Mui-focused, &.Mui-expanded': {
                                                                    backgroundColor: '#487FFF',
                                                                    color: '#fff'
                                                                },
                                                            }}
                                                        >


                                                            <MenuItem onClick={() => handleOpenProfile(user)}
                                                                sx={{
                                                                    fontFamily: 'indivisible',
                                                                    color: '#4B5563',
                                                                    fontWeight: '400',
                                                                    fontSize: '13px',
                                                                }}>
                                                                View
                                                            </MenuItem>
                                                        </Select>
                                                    </FormControl>

                                                </td>
                                            </>
                                        )}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="20" className="text-center py-3">
                                        No data found
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div>
                {scrollState.scrollWidth > scrollState.clientWidth && (
                    <div className="sticky-scroll-container">
                        <div className="sticky-scroll-track" onClick={handleStickyScroll}>
                            <div
                                ref={scrollThumbRef}
                                className="sticky-scroll-thumb"
                                style={{
                                    width: `${thumbWidth}px`,
                                    transform: `translateX(${thumbPosition}px)`
                                }}
                                onMouseDown={handleThumbDrag}
                            />
                        </div>
                    </div>
                )}
            </div>
            {/* Pagination */}
            {!loading && Boolean(totalPages) && <div className="d-flex justify-content-center mt-16">
                <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                     sx={{
    "& .MuiPaginationItem-root": {
      color: "#000",  
      border: "1px solid #ddd",
    },

    "& .Mui-selected": {
      backgroundColor: "#ff4a4a !important",  
      color: "#fff",
    },

    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#ffe5e5",
    },
  }} 
                />
            </div>}


            <Modal
                open={openProfile}
                onClose={handleCloseProfile}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style2}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: '0px',
                            backgroundColor: 'white',
                            zIndex: 10,
                            padding: '10px',
                            borderBottom: 'none',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <IconButton
                            sx={{
                                position: 'absolute',
                                top: 10,
                                right: 0,
                            }}
                            onClick={handleCloseProfile}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    {/* <ProfileCard userId={selectedUser?._id} /> */}
                    <UserProfileMainPage userId={selectedUser?._id} isDeletedAccount={true}/>
                </Box>
            </Modal>


        </>
    );
};

export default DeletedAccountList;
